import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';
import { GetUsers, ChangeUserState, ResendInvite, ClearAction } from '../store/user-managment.actions';
import { Router, ActivatedRoute } from '@angular/router';
import { map, last, withLatestFrom, debounceTime } from 'rxjs/operators';
import { MatSlideToggleChange, MatTableDataSource, MatDialog, MatTable } from '@angular/material';
import { UserBulkInviteComponent } from '../user-bulk-invite/user-bulk-invite.component';
import { NotificationModalComponent } from "../../../common-components/notification-modal/notification-modal.component";
import { ReplaceUserComponent } from '../replace-user/replace-user.component';
import { ResetUserComponent } from '../reset-user/reset-user.component';
import { GetUserCapabilites } from 'src/app/login/store/auth.actions';
import { FormControl } from '@angular/forms';
import { NgxPermissionsService } from 'ngx-permissions';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { LoaderHide, LoaderShow } from 'src/app/features/loader/store/loader.actions';
import { PAGE_LIMIT } from 'src/app/app.constants';






@Component({
    selector: 'app-users-list',
    templateUrl: './users-list.component.html',
    styleUrls: ['./users-list.component.scss']
})


export class UsersListComponent implements OnInit {
    displayedColumns: string[] = ['name', 'role', 'email', 'action', 'status', 'resend'];
    users$;
    page = 1;
    totalPages: number;
    tableData: Array<any> = [];
    dataSource;
    hideActionColumn: boolean = false;
    searchInput = new FormControl();
    searchString: string;
    showSearchResults: boolean = false;
    sortFields: any = ['firstName', 'email'];
    sortFlag: boolean = false;
    sortOn: string = '';
    firstName: boolean = false;
    email: boolean = false;
    isdataloading: boolean = false;
    currentPage = 1;
    count: number = 0;
    limitPerPageOptions;

    pageSizeDefault = '40';
    pageSize = this.pageSizeDefault;

    @ViewChild('usersTable', {static: false})
    usersTable: ElementRef;

    constructor(
        private store: Store<AppState>,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private ngxPermissionService: NgxPermissionsService,
        private dialog: MatDialog
    ) { }


    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    pageEvent: PageEvent;

    ngOnInit() {
        this.limitPerPageOptions = PAGE_LIMIT;

        this.searchInput.valueChanges.pipe(debounceTime(1000)).subscribe(searchString => {
            this.searchString = searchString;
            this.showSearchResults = true;
            this.store.dispatch(new GetUsers({ search: searchString, page: 1, 
                limit: this.pageSize, sortBy: this.sortOn, ascending: this.sortFlag }));
        });

        this.store.dispatch(new GetUsers({ limit: this.pageSize, page: this.page, sortBy: this.sortOn, ascending: this.sortFlag }));
        // this.store.dispatch(new GetUserCapabilites());
        // this.store.select(state => state.auth.user['capabilities']).subscribe(response => {
        //     if ((response || []).length) {
        // let capabilities = response[0].capabilities;
        const capabilities = (Object.keys(this.ngxPermissionService.getPermissions()) || []);
        if (capabilities.includes("change-user-role")) {
            this.hideActionColumn = false;
        }
        else {
            this.hideActionColumn = true;
        }
        // }
        // })
        this.store.select(state => state.userManagment.users).subscribe((users: any) => {
            this.pageSize = this.pageSizeDefault;

            this.store.dispatch(new LoaderHide());
            if (users !== undefined && Object.keys(users).length) {
                this.isdataloading = false;
                const usersList = users.data.map(user => ({
                    ...user,
                    name: (user.firstName || ' ') + ' ' + (user.middleName || ' ') + ' ' + (user.lastName || ' ')
                    // cities: (user.cities || []).join().length > 0 ? (user.cities || []).join() : 'NA'
                }));
                this.totalPages = users.pages;
                this.count = users.count;
                this.currentPage = users.page;
                this.tableData = [...usersList];
            }
            // this.dataSource = new MatTableDataSource(this.tableData);
            this.dataSource = [...this.tableData];
            if (this.usersTable) {
                this.usersTable.nativeElement.scrollTop = 0;
            }
        }
        );
    }

    getName(name) {
        return ((name || '').trim()).length > 0 ? name : ' ';
    }

    onInviteClick() {
        this.router.navigate(['../invite-user'], { relativeTo: this.activatedRoute });
    }

    onBulkInviteClick() {
        const dialogRef = this.dialog.open(UserBulkInviteComponent, {
            width: '60%',
            panelClass: "cmp-modal",
            data: {
                alertTitle: 'Bulk Invite',
                type: 'userManagement'
            }

        });
        dialogRef.afterClosed().subscribe(response => {
            this.clearSearch();
        })
        // this.router.navigate(['../bulk-invite-user'], { relativeTo: this.activatedRoute });
    }
    OnUserStatusChanges(event: MatSlideToggleChange, user) {
        event.source.checked = user.is_active;

        this.store.dispatch(new ClearAction());
        this.store.dispatch(new ChangeUserState(user._id));
        this.store.select(state => state.userManagment.changeUserStateRes).subscribe(response => {
            if (Object.keys(response).length) {
                this.clearSearch();
                // user.is_active = !user.is_active;
                // event.source.checked = !user.is_active;
            }
        })
        this.page = 0;
    }

    viewDetails(id) {
        this.router.navigate(['../details/' + id], { relativeTo: this.activatedRoute });
    }

    allUserDetails() {
        this.page++;
        let apiData = {
            limit: 40,
            page: this.page,
            sortBy: this.sortOn,
            ascending: this.sortFlag
        };
        if (this.page <= this.totalPages) {
            if (this.showSearchResults) {
                apiData['search'] = this.searchString;
            }

            this.isdataloading = true;
            this.store.dispatch(new GetUsers(apiData));
        }
    }
    onScroll(event) {
        const tableViewHeight = event.target.offsetHeight; // viewport: ~500px
        const tableScrollHeight = event.target.scrollHeight; // length of all table
        const scrollLocation = event.target.scrollTop; // how far user scrolled
        // If the user has scrolled within 200px of the bottom, add more data
        const buffer = 0;
        const limit = tableScrollHeight - tableViewHeight - buffer;
        if (scrollLocation >= limit) {
            if (!this.isdataloading) {
                this.allUserDetails();
            }
        }

    }

    editRole(element) {
        this.router.navigate(['home', 'user-management', 'edit-user', element._id]);
    }

    resendInvite(element) {

        const dialogRef = this.dialog.open(NotificationModalComponent, {
            width: '450px',
            panelClass: 'cmp-modal',
            data: {
                text: "Are you sure you want to resend this invitation?"
            },
            hasBackdrop: true
        });
        dialogRef.afterClosed().subscribe((response) => {
            if (response !== undefined && response) {
                if (element._id) {
                    const payload = {
                        id: element._id,
                        role: element.role
                    };
                    this.store.dispatch(new ResendInvite(payload));
                }
            }
        });
    }


    showUserActivity(userObj) {
        this.router.navigate(['home', 'user-management', 'user-activity', userObj._id]);
    }

    replaceUser(userObj) {
        const dialogref = this.dialog.open(ReplaceUserComponent, {
            hasBackdrop: true,
            width: '700px',
            panelClass: 'task-detail-modal',
            data: {
                alertTitle: 'Replace User',
                userToBeReplaced: userObj,
            }
        });
    }

    resetUser(userObj) {
        const dialogref = this.dialog.open(ResetUserComponent, {
            hasBackdrop: true,
            width: '700px',
            panelClass: 'task-detail-modal',
            data: {
                alertTitle: 'Reset User',
                userToBeReset: userObj,
            }
        });
    }

    clearSearch() {
        this.searchInput.setValue("");
    }

    sortUsersBy(sortParam) {
        this.sortFields.map(field => {
            field == sortParam ? this[sortParam] = true : this[field] = false
        })

        if (sortParam == this.sortOn) {
            this.sortFlag = !this.sortFlag
        }
        else {
            this.sortOn = sortParam
            this.sortFlag = true
        }

        const params = {
            page: 1,
            limit: this.pageSize,
            sortBy: this.sortOn,
            ascending: this.sortFlag,
            search: this.searchString ? this.searchString : ""
        }
        this.store.dispatch(new GetUsers(params));
    }

    getServerData(event) {
        const params = {
            page: event,
            limit: this.pageSize,
            sortBy: this.sortOn,
            ascending: this.sortFlag,
            search: this.searchString ? this.searchString : ""
        };

        this.store.dispatch(new LoaderShow());
        this.store.dispatch(new GetUsers(params));
    }

    onChange(event) {

        const params = {
            page: 1,
            limit: event.value,
            sortBy: this.sortOn,
            ascending: this.sortFlag,
            search: this.searchString ? this.searchString : ""
        };

        this.store.dispatch(new LoaderShow());
        this.store.dispatch(new GetUsers(params));
    }
}
